export default function renderValidation(pilot, userData) {
  const fromROS =
    document.referrer.match(/amdev.apfym-nonprod.collegeboard.org/g) ||
    document.referrer.match(/uat.apfym-nonprod.collegeboard.org/g) ||
    document.referrer.match(/pentest.apfym-nonprod.collegeboard.org/g) ||
    document.referrer.match(/myap.collegeboard.org/g) ||
    [];

  let error = -1;
  // number correlates to error id in ERRORS object within the copy/index.js file

  if (!userData.me) {
    return error;
  }

  let levityProfile = false;
  if (window.cb && window.cb.core) {
    levityProfile = window.cb.core.iam.getAuthSession().basicProfile;
  }

  /*
   * Create additional fallback for user type detection based
   * on a data from levity.
   **/
  const isStudent =
    userData.me.isStudent ||
    userData.me.userRole.includes('student') ||
    (levityProfile && levityProfile.isStudent);
  const isTeacher =
    userData.me.isTeacher ||
    userData.me.userRole.includes('teacher') ||
    (levityProfile && levityProfile.isProfessional); // FIXME: not only teachers
  const isAdminOrCoordinator =
    userData.isAdmin ||
    userData.isCoordinator ||
    userData.me.userRole.includes('admin') ||
    userData.me.userRole.includes('coordinator') ||
    // levity tells you from the namespace whether it is an educator/professional (pf) or student account (st)
    (levityProfile && levityProfile.namespace === 'pf');

  const userSubjects = isStudent
    ? userData.studentSubjects
    : userData.teacherSubjects || [];

  switch (pilot) {
    case CURRENT_PILOT_NAME:
      switch (userData.me.pilot) {
        case pilot:
          if (isStudent) {
            if (window.location.pathname === '/error/1') {
              // enrollment mismatch
              error = 1;
            } else if (!(userSubjects || []).length) {
              // empty enrollment
              error = 2;
            } else if (!(userData.me.schoolSet || []).length) {
              // unknown school
              error = 3;
            }
          } else if (isAdminOrCoordinator) {
            // no special validation, and NOT A TEACHER
          } else if (isTeacher) {
            // teacher with unknown school or empty subjects
            if (!userSubjects.length || !(userData.me.schoolSet || []).length) {
              error = 4;
            }
          } else if (!(userData.me.userRole || []).length) {
            // unknown user roles
            error = 4;
          }
          break;
        default:
          /*
           * student is on p2 but not part of the pilot or has no subjects and came not from ROS
           **/
          if (isStudent) {
            error = 0;
          }
          if (isStudent && fromROS.length) {
            error = 2;
          }
          /*
           * error for teacher not participating p2
           * different messages if from ros/not from ros.
           **/
          if (isTeacher) {
            error = 7;
          }
          /*
           * teacher clicked AP CLASSROOM link from any of the
           * document.referrer CB applications
           **/
          if ((isAdminOrCoordinator || isTeacher) && fromROS.length) {
            /* eslint-disable */
            console.log('renderValidation redirect', {
              isAdminOrCoordinator,
              isTeacher,
              'fromROS.length': fromROS.length,
              levityProfile,
            });
            /*eslint-enable */
            // redirect to collegeboard app for proper message
            // see https://academicmerit.atlassian.net/browse/FY-8630
            window.location.href = `${ROS_FRONTEND_URL}`;
          }
          /*
           * a fallback for the cases where user role can't be detected and pilot is not infra
           **/
          if (!(userData.me.userRole || []).length) {
            /*
             * for teacher or coordinator that we cannot determine their
             * roles we get their information from levityProfile
             **/
            if (isTeacher || isAdminOrCoordinator) {
              // redirect to collegeboard app for proper message
              // see https://academicmerit.atlassian.net/browse/FY-8630
              // error = 5;
              /* eslint-disable */
              console.log('renderValidation redirect pt2', {
                isAdminOrCoordinator,
                isTeacher,
                userData,
                levityProfile,
              });
              /*eslint-enable */
              window.location.href = `${ROS_FRONTEND_URL}`;
            } else {
              // for student just fallback to the default 5 error page
              error = 5;
            }
          }
          break;
      }
      break;
    default:
      return error;
  }
  return error;
}
